export default __webpack_public_path__ + "static/media/onboardingBg.5ce47502.png";